import classNames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { useDisplayNameFormatter } from 'components/DisplayNameFormatter/useDisplayNameFormatter';
import { css } from 'config/emotionCss';
import colors from 'config/theme/colors';
import { stopImpersonateUser } from 'modules/auth/actions';
import { getCurrentUserAdditionalData, getCurrentUserIsLoading } from 'modules/users/selectors/currentUser';
import Button from 'ui/base/Button';
import { b } from 'utils/i18nUtils';

const impersonateStyle = css`
  height: 55px;
  background-color: #faad14;

  > .ant-btn {
    color: ${colors['@label-color']};
    border-color: ${colors['@label-color']};
  }
`;

/** @type {React.FC<unknown>} */
const ImpersonateBanner = () => {
  const dispatch = useDispatch();
  const loading = useSelector(getCurrentUserIsLoading);
  const user = useSelector(getCurrentUserAdditionalData);
  const formatDisplayName = useDisplayNameFormatter();

  const handleOnClick = React.useCallback(() => {
    dispatch(stopImpersonateUser());
  }, [dispatch]);

  return (
    <div
      className={classNames(impersonateStyle, 'd-flex align-items-center justify-content-center gap-2')}
      data-cy="impersonate-banner"
      id="impersonate-banner"
    >
      <span className="fb-icon--warning" />
      <span>
        <FormattedMessage
          id="page.login.behalf.describe"
          defaultMessage='Warning, your are currently using Fleetback with the role of <b>"{username}"</b>.'
          values={{ b, username: formatDisplayName(user) }}
        />
      </span>
      <Button onClick={handleOnClick} loading={loading} ghost data-cy="stop-impersonate-btn">
        <FormattedMessage id="page.login.behalf.back" defaultMessage="Back to my user" />
      </Button>
    </div>
  );
};

export default ImpersonateBanner;
